import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class RestrainRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Letiltás partner</TableCell>
                            <TableCell>Év</TableCell>
                            <TableCell>Hónap</TableCell>
                            <TableCell>Összeg</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.employeeName}</TableCell>
                            <TableCell>{this.props.row.restrainPartnerName}</TableCell>
                            <TableCell>{this.props.row.salaryYear}</TableCell>
                            <TableCell>{this.props.row.salaryMonth}</TableCell>
                            <TableCell>{this.props.row.amount}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default RestrainRow;